function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const countBubble = document.querySelector('.cart-count');
      if (countBubble) {
        countBubble.textContent = cart.item_count;
      }
    });
}

// Run once on page load
document.addEventListener('DOMContentLoaded', updateCartCount);

// Update after cart changes
document.addEventListener('cart:refresh', () => {
  window.updateCartCount();
});

// Also expose for manual use if needed
window.updateCartCount = updateCartCount;
